import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import { useState, useEffect } from 'preact/hooks'

import { useActions, useAppState } from '@nosto/preact'
import { useProductFilters } from '@nosto/preact'

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Select from "./elements/Select"

import { sortOptions } from "../config"


import Icon from "./elements/Icon"

function ToggleSidebarButton({ className }) {
    return (
        // <label
        //     className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
        //     for="toggle-mobile-sidebar"
        // >
        //     <Icon name="close" />
        // </label>
        <label for="toggle-mobile-sidebar" type="button" class={`ns-act-btn ns-close-sidebar btn-none ${className}`} data-results-filter-toggle="">
            <svg aria-label="Cross icon" class="icon icon--cross" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.6 0.6H23.4V23.4H0.6V0.6Z" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke" class="icon-outline"></path>
                <path d="M17.4545 17.4545L11.9446 12M11.9446 12L6.54541 6.65505M11.9446 12L17.4545 6.54541M11.9446 12L6.54541 17.3449" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke"></path>
            </svg>
        </label>
    )
}



export default function SideBar({ toggleId }) {
    const { loading, facets } = useFacets()
    const [activeFacet, setActiveFacet] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const { activeSort, setSort } = useSort(sortOptions);


    /* ADDING FOR APPLY ALL BUTTON */
    // const { response, response: { products: { facets } } = {} } = useAppState()
    const { updateSearch } = useActions()
    const { filters, removeAll } = useProductFilters()
    const { toggleProductFilter } = useActions()

    const isMobile = true;

    const handleApplyFilters = () => {
        selectedItems.forEach((item) => {
          toggleProductFilter(item.facet, item.value, item.selected);
        });
        //setSelectedItems([]);
        const closeButton = document.querySelector(".ns-act-btn.ns-close-sidebar");
        closeButton.click();
      };

      useEffect(() => {
        if (loading) {
            setActiveFacet('')
        }
    }, [loading])
    /* END EXTRA CODE FOR APPLY ALL BUTTON */


    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    useEffect(()=>{
        document.querySelectorAll(".nosto-sort").forEach(el => {
            el.querySelector("a").addEventListener("click", function(){
                if(this.parentElement.classList.contains("ns-active")) this.parentElement.classList.remove("ns-active");
                else this.parentElement.classList.add("ns-active");
            })
        })
    }, [])


    useEffect(()=>{
        document.querySelectorAll(".nosto-sort-box").forEach(el =>{
            if(el.classList.contains(activeSort)) el.classList.add("active-sort")
        });

        // if(window.outerWidth <= 768){
        //     var headerHeight = jQuery("header")[0].offsetHeight;
        //     jQuery("form.results-navbar").css("top", headerHeight + "px");
        // }
        if (window.outerWidth <= 768) {
            const header = document.querySelector("header");
            const form = document.querySelector("form.results-navbar");
        
            if (header && form) {
                form.style.top = `${header.offsetHeight}px`;
            }

            
        }
        
    })


    return facets?.length > 0 ? (
        <>
        <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-h-100 ns-mr-0 ns-mr-md-auto">
                    {/* <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline ns-p-4">
                        <span class="nosto-facet-name">FILTER &amp; SORTING</span>
                        <ToggleSidebarButton />
                    </div> */}
                    <div class="results-filter__header">
                    <ToggleSidebarButton />
                    <span class="text--small">Filter &amp; Sorting</span>
                    </div>
                    <div class="ns-sidebar-menu">
                        <SelectedFilters/>
                        <Select
                            value={activeSort}
                            className="ns-selection-dropdown-sort-menu"
                            options={options}
                            
                        />
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} isActive={activeFacet === facet.id}
                                        setActive={(active) => {
                                            if (active) {
                                                setActiveFacet(facet.id)
                                            } else {
                                                setActiveFacet('')
                                            }
                                        }} selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems}
                                        />
                                    case "stats":
                                        return <RangeFacet facet={facet} isActive={activeFacet === facet.id}
                                        setActive={(active) => {
                                            if (active) {
                                                setActiveFacet(facet.id)
                                            } else {
                                                setActiveFacet('')
                                            }
                                        }}/>
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                        <div class="buttons-container-sidebar" style="">
                            <a
                                href="javascript:void(0)"
                                class="ns-button-removeall"
                                onClick={() => {
                                    removeAll()
                                }}
                            >
                                <span>Clear All</span>
                            </a>
                            <button class="button apply-filters"
                                        onClick={handleApplyFilters}
                                    >
                                    <span>APPLY </span>
                                    {/* ({selectedItems.length}) */}
                            </button>
                            {/* {selectedItems.length > 0 && <button class="button remove-filters"
                             onClick={() => {
                            removeAll();
                            setSelectedItems([]);
                        }}  >REMOVE FILTERS</button>} */}
                            
                        </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
